import React from "react";
import { Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import { useGoogleAnalytics } from "hooks/useGoogleAnalytics";

// Direct imports instead of lazy loading to fix dynamic import error
import Homepage from 'pages/homepage';
import ServicesPage from 'pages/services';
import ExpertisePage from 'pages/expertise';
import ProfessionalTrainingServicesPage from 'pages/professional-training-services';
import StrategicConsultingServicesPage from 'pages/strategic-consulting-services';
import ConferenceOrganizationServicesPage from 'pages/conference-organization-services';
import ResearchStudiesServicesPage from 'pages/research-studies-services';
import TrainingDevelopmentServicesPage from 'pages/training-development-services';
import DigitalMarketingServicesPage from 'pages/digital-marketing-services';
import TrainingDevelopmentHub from 'pages/training-development-hub';
import AISolutionsIntegrationHubPage from 'pages/ai-solutions-integration-hub';
import DigitalProjectManagementServicesPage from 'pages/digital-project-management-services';
import HumanResourcesManagementServicesPage from 'pages/human-resources-management-services';
import BusinessTherapyServicesPage from 'pages/business-therapy-services';
import OurStoryPage from 'pages/our-story';
import OurVisionPage from 'pages/our-vision';
import OurTeamPage from 'pages/our-team';
import ContactPage from 'pages/contact';
import BusinessTherapyProcessPage from 'pages/business-therapy-process';
import BlogHub from 'pages/blog-hub';
import AIAutomotiveExcellenceArticle from 'pages/ai-in-automotive-excellence-article';
import SkillsDevelopmentArticle from 'pages/skills-development-in-digital-era-article';
import ServiceRequestForm from 'pages/service-request-form';
import InformationRequestForm from 'pages/information-request-form';
import COPAFRegistrationForm from 'pages/copaf-registration-form';
import CertificationsPage from 'pages/certifications';
import PartnersResourcesHub from 'pages/partners-resources-hub';
import PartnersPage from 'pages/about/partners';
import CompanyOverviewPage from 'pages/about/company-overview';
import ResourcesPage from 'pages/about/resources';

// Wrapper component to use hooks that require Router context
const RoutesWithAnalytics = () => {
  useGoogleAnalytics();
  
  return (
    <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Homepage />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/expertise" element={<ExpertisePage />} />
        <Route path="/professional-training-services" element={<ProfessionalTrainingServicesPage />} />
        <Route path="/strategic-consulting-services" element={<StrategicConsultingServicesPage />} />
        <Route path="/conference-organization-services" element={<ConferenceOrganizationServicesPage />} />
        <Route path="/research-studies-services" element={<ResearchStudiesServicesPage />} />
        <Route path="/training-development-services" element={<TrainingDevelopmentServicesPage />} />
        <Route path="/digital-marketing-services" element={<DigitalMarketingServicesPage />} />
        <Route path="/training-development-hub" element={<TrainingDevelopmentHub />} />
        <Route path="/ai-solutions-integration-hub" element={<AISolutionsIntegrationHubPage />} />
        <Route path="/digital-project-management-services" element={<DigitalProjectManagementServicesPage />} />
        <Route path="/human-resources-management-services" element={<HumanResourcesManagementServicesPage />} />
        <Route path="/business-therapy-services" element={<BusinessTherapyServicesPage />} />
        <Route path="/business-therapy-process" element={<BusinessTherapyProcessPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/service-request-form" element={<ServiceRequestForm />} />
        <Route path="/information-request-form" element={<InformationRequestForm />} />
        <Route path="/copaf-registration-form" element={<COPAFRegistrationForm />} />
        <Route path="/our-story" element={<OurStoryPage />} />
        <Route path="/our-vision" element={<OurVisionPage />} />
        <Route path="/our-team" element={<OurTeamPage />} />
        <Route path="/blog-hub" element={<BlogHub />} />
        <Route path="/ai-in-automotive-excellence-article" element={<AIAutomotiveExcellenceArticle />} />
        <Route path="/skills-development-in-digital-era-article" element={<SkillsDevelopmentArticle />} />
        <Route path="/about/certifications" element={<CertificationsPage />} />
        <Route path="/about/partners" element={<PartnersPage />} />
        <Route path="/about/company-overview" element={<CompanyOverviewPage />} />
        <Route path="/about/resources" element={<ResourcesPage />} />
        <Route path="/partners-resources-hub" element={<PartnersResourcesHub />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
    </ErrorBoundary>
  );
};

export default RoutesWithAnalytics;